import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

export default defineNuxtPlugin(() => {
  const { public: { cognitoUserPoolId, cognitoClientId, cognitoCookieStorageDomain } } = useRuntimeConfig()

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognitoUserPoolId,
        userPoolClientId: cognitoClientId,
      },
    },
  })

  cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({
    domain: cognitoCookieStorageDomain,
    path: '/',
    expires: 365,
  }))
})
